export const boardCardColors = [
  '#ffff99',
  '#ffff00',
  '#ffcc66',
  '#ff9900',
  '#ff66ff',
  '#ff00cc',
  '#cc99ff',
  '#9999ff',
  '#66ffff',
  '#33ccff',
  '#99ff66',
  '#66ff00',
  '#ff0033',
  '#000000',
  '#ffffff',
  '#f9faf9',
];

export const imageCardColors = [
  '#ffffff',
  '#ffff99',
  '#ffff00',
  '#ffcc66',
  '#ff9900',
  '#ff66ff',
  '#ff00cc',
  '#cc99ff',
  '#9999ff',
  '#66ffff',
  '#33ccff',
  '#99ff66',
  '#66ff00',
  '#ff0033',
  '#000000',
  '#f9faf9',
];
